module.exports = __webpack_public_path__ + "img/背景图.5e8860f1.png";